export const scrollToElement = (id) => {
	const el = document.getElementById(id);
	if (el) {
		el.scrollIntoView({behavior: 'smooth', block: 'center'});
	}
};
